import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { PublicQuestionnaire } from "./components/shir-derech/PublicQuestionnaire";

// Public Shir-Derech questionnaire pages render OUTSIDE the WorkOS auth gate
// so participants can fill them without an account. Everything else goes
// through <App /> (sign-in required).
const publicForm = window.location.pathname.match(
  /^\/form\/shir-derech\/(opening|closing)\/?$/,
);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {publicForm ? (
      <PublicQuestionnaire kind={publicForm[1] as "opening" | "closing"} />
    ) : (
      <App />
    )}
  </StrictMode>,
);
